"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_14a7ujeyak() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Map.tsx";
  var hash = "1668ac1e15e0640b8e7108f0af3747190388a01e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Map.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 43
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1668ac1e15e0640b8e7108f0af3747190388a01e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_14a7ujeyak = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_14a7ujeyak();
var Icon = (cov_14a7ujeyak().s[0]++, {
  name: 'map',
  svg: "<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M1 2.57341976L1 16.7103251 6.00045887 15.4244928 6.00883523 1.27356913 6.00591467 1.27303532 1 2.57341976zM6.00883599 1.27227645L6.00886384 1.22522092 6.21977824 1.21748006 6.00883599 1.27227645zM12 2.5753892L12 16.353089 12.7961009 16.5056134 17 15.4246108 17 1.28967491 12 2.5753892z\"></path><path d=\"M12,2.6 L7.00891689,1.4770063 L6,1.83186439 L6,15.4 L11.1262056,16.5533963 L12,16.5301385 L12,2.6 Z\"></path></g>"
});
var _default = exports["default"] = Icon;